import { IMG } from 'conversations-message-history/common-message-format/constants/fileAttachmentTypes';
// @ts-expect-error Could not find a declaration file
import { displayName } from 'conversations-internal-schema/file-metadata/operators/displayName';
import { getExtension, getSize, getType, getUrl
// @ts-expect-error Could not find a declaration file
} from 'conversations-internal-schema/file-metadata/operators/fileMetadataGetters';
import FormattedSize from 'I18n/components/FormattedSize';
import { PureComponent } from 'react';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import { FileAttachment } from 'foundations-components/transitional/components/FileAttachment';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
class FileAttachmentTile extends PureComponent {
  render() {
    const {
      fileMetadata,
      genericChannelId
    } = this.props;
    const name = displayName(fileMetadata);
    const url = getUrl(fileMetadata);
    const size = getSize(fileMetadata);
    const type = getType(fileMetadata);
    const extension = getExtension(fileMetadata);
    const useImagePreview = type === IMG && extension !== 'svg';
    const handleClickAttachment = () => {
      usageTracker.track('click-attachment', {
        action: 'click attachment',
        channel: getUsageTrackingChannel(genericChannelId)
      });
    };
    return /*#__PURE__*/_jsx(View, {
      maxInlineSize: "300px",
      children: /*#__PURE__*/_jsx(Link, {
        href: url,
        target: "_blank",
        use: "unstyled",
        onClick: handleClickAttachment,
        children: /*#__PURE__*/_jsx(FileAttachment, {
          fileName: /*#__PURE__*/_jsx(TruncateString, {
            children: name
          }),
          fileInfo: /*#__PURE__*/_jsx(FormattedSize, {
            value: size
          }),
          marginBlock: "200",
          size: "small",
          renderPreview: useImagePreview ? () => /*#__PURE__*/_jsx(Image, {
            alt: name,
            shape: "thumbnail",
            src: url
          }) : undefined
        })
      })
    });
  }
}
FileAttachmentTile.displayName = 'FileAttachmentTile';
export default FileAttachmentTile;